angular.module('dentalLinksServices')

.factory('Impersonation', ['$resource', '$cookies', 'API_ENDPOINT', 
    function($resource, $cookies, API_ENDPOINT) {
        return $resource(API_ENDPOINT + '/impersonate/:action', {}, {
            start: { method: 'POST', params: { action: 'start' }, withCredentials: true },
            stop: { method: 'POST', params: { action: 'stop' }, withCredentials: true },
            status: { method: 'GET', params: { action: 'status' }, withCredentials: true }
        });
    }
])

.factory('ImpersonationState', ['$cookies', '$rootScope',
    function($cookies, $rootScope) {
        return {
            isImpersonating: function() {
                // The impersonation cookie is set by backend and readable by frontend
                var impersonationCookie = $cookies.get('impersonation');
                return !!impersonationCookie;
            },
            getImpersonationInfo: function() {
                var impersonationCookie = $cookies.get('impersonation');
                if (impersonationCookie) {
                    try {
                        // Replace + with space before parsing (Rails encodes spaces as + in cookies)
                        var decoded = impersonationCookie.replace(/\+/g, ' ');
                        return JSON.parse(decoded);
                    } catch (e) {
                        return null;
                    }
                }
                return null;
            },
            notifyChange: function() {
                $rootScope.$broadcast('impersonation:changed');
            }
        };
    }
]);
